export default function Footer() {
  return (
    <footer className="py-4 text-center text-sm text-content-tertiary">
      v{__APP_VERSION__}
    </footer>
  )
}
